export default function objectKeys<T extends string | number, U extends Partial<Record<T, unknown>>>(
  obj: U
): (keyof U)[] {
  return Object.keys(obj) as (keyof U)[]
}
